import firebase from 'firebase';
import React from 'react';
import { useDocumentDataOnce } from 'react-firebase-hooks/firestore';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { FirebaseUser } from '../../../types/types';
import { LoadingPage } from '../../util-pages/LoadingPage';
import { NotFoundPage } from '../../util-pages/NotFoundPage';

export const GuardedAdminPage: React.FC = ({ children }) => {
  const currentUser = useCurrentUser();
  const [userData] = useDocumentDataOnce<FirebaseUser>(
    currentUser && firebase.firestore().collection('users').doc(currentUser.uid)
  );

  if (!currentUser || !userData) return <LoadingPage isHeader />;

  if (!userData.isAdmin) return <NotFoundPage />;

  return <>{children}</>;
};
